import { Outlet, useParams, Navigate } from "react-router-dom";
import { useEffect } from "react";
import i18n from "../i18n/index";

const SUPPORTED_LANGS = ["ko", "en"] as const;

export default function LanguageLayout() {
  const { lang } = useParams();

  useEffect(() => {
    if (lang && SUPPORTED_LANGS.includes(lang as any)) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  if (!lang || !SUPPORTED_LANGS.includes(lang as any)) {
    return <Navigate to="/ko" replace />;
  }

  return <Outlet />;
}
